// Generated by purs version 0.15.15
import * as ConvertableOptions from "../ConvertableOptions/index.js";
import * as Visonum_Cross_Style from "../Visonum.Cross.Style/index.js";
import * as Visonum_Cross_ToCss from "../Visonum.Cross.ToCss/index.js";
import * as Visonum_Cross_Util from "../Visonum.Cross.Util/index.js";
var toCss = /* #__PURE__ */ Visonum_Cross_Style.toCss(Visonum_Cross_Style.isStylesString);
var toCss1 = /* #__PURE__ */ Visonum_Cross_Style.toCss(Visonum_Cross_Style.isStylesArrayString);
var css = /* #__PURE__ */ Visonum_Cross_ToCss.css(Visonum_Cross_ToCss.toCssStringColor);
var width100pct = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss("width: 100%"));
var padding16px = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss("padding: 16px"));
var height96 = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss("height: 96px"));
var height100pct = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss("height: 100%"));
var fontWeightSemiBold = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss1([ "font-weight: 600" ]));
var fontWeightBold = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss1([ "font-weight: 800" ]));
var fontWeight700 = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss1([ "font-weight: 700" ]));
var fontWeight600 = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss1([ "font-weight: 600" ]));
var fontVodafoneBold = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss1([ "font-family: vodafone-bold" ]));
var fontSize56 = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss1([ "font-size: 56px" ]));
var fontSize24 = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss1([ "font-size: 24px" ]));
var fontSize20 = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss1([ "font-size: 20px" ]));
var fontSize16 = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss1([ "font-size: 16px" ]));
var fontSize14 = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss1([ "font-size: 14px" ]));
var fontOutfit = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss1([ "font-family: Outfit" ]));
var fontInter = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss1([ "font-family: Inter" ]));
var flexRow = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss1([ "display: flex", "flex-direction: row" ]));
var flexColumn = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss1([ "display: flex", "flex-direction: column" ]));
var debugOutline = function (dictDefaults) {
    var $7 = ConvertableOptions.defaults(dictDefaults)({});
    return function ($8) {
        return (function (v) {
            return Visonum_Cross_Style.unStyle(toCss("outline: 1px solid lime"));
        })($7($8));
    };
};
var color = function (c) {
    return Visonum_Cross_Style.unStyle(toCss1([ Visonum_Cross_Util.appendWithSpace("color:")(css(c)) ]));
};
var boxSizingBorderBox = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss("box-sizing: border-box"));
var borderRadius8px = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss("border-radius: 8px"));
var borderRadius5px = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss("border-radius: 5px"));
var backgroundColor = function (c) {
    return Visonum_Cross_Style.unStyle(toCss1([ Visonum_Cross_Util.appendWithSpace("background-color:")(css(c)) ]));
};
var alignItemsCenter = /* #__PURE__ */ Visonum_Cross_Style.unStyle(/* #__PURE__ */ toCss1([ "align-items: center" ]));
export {
    alignItemsCenter,
    backgroundColor,
    borderRadius5px,
    borderRadius8px,
    boxSizingBorderBox,
    color,
    debugOutline,
    flexColumn,
    flexRow,
    fontInter,
    fontOutfit,
    fontSize14,
    fontSize16,
    fontSize20,
    fontSize24,
    fontSize56,
    fontWeight600,
    fontWeight700,
    fontWeightBold,
    fontWeightSemiBold,
    fontVodafoneBold,
    height100pct,
    height96,
    padding16px,
    width100pct
};
